import { useMutation, useQuery } from "react-query";
import {
  getCompanyStats,
  getCompanyUsers,
  getCompanyDetails,
  getExportExcel,
  deleteCompany,
  addUserToCompany,
  addBulkUsersToCompanies,
  removeUserAccess,
  deleteCompanyRequest,
  editCompanyRequest,
  getGlobalInvestors,
  linkGlobalInvestors,
  linkCompanyInvestors,
} from "../../api/captableStats";

const COMPANY_STATS_STALE_TIME_MS = 5 * 60 * 1000;
const COMPANY_STATS_CACHE_TIME_MS = 30 * 60 * 1000;

export const companyUsersQueryKey = (companyId: string) => [
  "companyUsers",
  companyId,
];

export function useGetCompanyStats() {
  return useQuery({
    queryKey: "getcompanystats",
    queryFn: (context) => getCompanyStats(context, false),
    enabled: true,
    retry: false,
    staleTime: COMPANY_STATS_STALE_TIME_MS,
    cacheTime: COMPANY_STATS_CACHE_TIME_MS,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

export function useRefreshCompanyStats() {
  return useMutation({
    mutationKey: "refreshCompanyStats",
    mutationFn: () => getCompanyStats(undefined, true),
    retry: false,
  });
}

export function useGetCompanyUsers(companyId: string) {
  return useQuery({
    queryKey: companyUsersQueryKey(companyId),
    queryFn: getCompanyUsers,
    enabled: Boolean(companyId),
    retry: false,
    staleTime: COMPANY_STATS_STALE_TIME_MS,
    cacheTime: COMPANY_STATS_CACHE_TIME_MS,
    refetchOnWindowFocus: false,
  });
}
export function useGetCompanyDetails(id: string) {
  return useQuery({
    queryKey: ["getcompanyDetails", id],
    queryFn: getCompanyDetails,
    enabled: true,
  });
}
export function useGetExportExcel() {
  return useMutation({
    mutationKey: "getExportExcel",
    mutationFn: getExportExcel,
  });
}
export function useDeleteCompany() {
  return useMutation({
    mutationKey: "deleteCompany",
    mutationFn: deleteCompany,
  });
}
export function usecompanyAccess() {
  return useMutation({
    mutationKey: "companyAccess",
    mutationFn: addUserToCompany,
  });
}
export function useBulkCompanyAccess() {
  return useMutation({
    mutationKey: "bulkCompanyAccess",
    mutationFn: addBulkUsersToCompanies,
  });
}
export function useRemoveUserAccess() {
  return useMutation({
    mutationKey: "removeUserAccess",
    mutationFn: removeUserAccess,
  });
}
export function useDeleteCompanyRequest() {
  return useMutation({
    mutationKey: "deleteCompanyRequest",
    mutationFn: deleteCompanyRequest,
  });
}
export function useEditCompanyRequest() {
  return useMutation({
    mutationKey: "editCompanyRequest",
    mutationFn: editCompanyRequest,
  });
}

export function useGetGlobalInvestors() {
  return useQuery({
    queryKey: "getGlobalInvestors",
    queryFn: getGlobalInvestors,
  });
}

export function useLinkGlobalInvestors() {
  return useMutation({
    mutationKey: "linkGlobalInvestors",
    mutationFn: linkGlobalInvestors,
  });
}

export function useLinkCompanyInvestors() {
  return useMutation({
    mutationKey: "linkCompanyInvestors",
    mutationFn: linkCompanyInvestors,
  });
}
